import { useState } from "react";

export function useExternalInternalString(value?: string, onChange?: (value: string | undefined) => void) {
  const [v, setV] = useState<string | undefined>(value);
  const realOnChange = onChange || setV;
  return {
    value: onChange ? value : v,
    onChange: realOnChange,
  };
}

export function useExternalInternalToggle(value?: boolean, onToggle?: () => void) {
  const [v, setV] = useState(value || false);
  const realOnToggle =
    onToggle ||
    (() => {
      setV(!v);
    });
  return {
    value: onToggle ? value : v,
    onToggle: realOnToggle,
  };
}
